import { PDFViewer, PDFDownloadLink } from "@react-pdf/renderer";
import PdfInvoice from "./PdfInvoice";

export default function InvoicePreview(props) {
  const fileName = `${props.customer.name || "Invoice"}-INVOICE.pdf`;

  return (
    <div className="mt-10">
      <h2 className="text-lg font-semibold mb-3">Invoice Preview</h2>

      <div className="border h-[600px] mb-4">
        <PDFViewer width="100%" height="100%">
          <PdfInvoice {...props} />
        </PDFViewer>
      </div>

      <PDFDownloadLink
        document={<PdfInvoice {...props} />}
        fileName={fileName}
        className="inline-block bg-purple-600 text-white px-6 py-2 rounded"
      >
        Download PDF
      </PDFDownloadLink>
    </div>
  );
}